//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import * as styles from './ko.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Header, MobileMenu } from '@cmp/common';
import KoInfoConsent from './koInfoConsent';
import KoAdsConsent from './koAdsConsent';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { TermsBanner, TermsBannerResponsive } from '@cmp/images';
//------------------------------------------------------------------------------
// Helpers ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// Import locale json ----------------------------------------------------------
import krjson from '../../../../public/locales/ko.json';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------

class KoTermsConditions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  componentDidMount() {
    const divId = window.location.hash.slice(1);
    const elem = document.getElementById(divId);
    if (elem) {
      elem.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    //deleting empty divs if any while rendering conditions table
    const divs = document.querySelectorAll('#mapperdiv, #tabp');
    divs.forEach((div) => {
      if (divs.innerHTML === '' || div.textContent === '') {
        div.remove();
      }
    });
  }

  handleToggle() {
    this.setState((state) => ({ toggle: !state.toggle }));
  }

  render() {
    const componentClasses = classNames(styles.KoTermsConditions);
    const { toggle } = this.state;
    const { handleToggle } = this;
    const { t } = this.props;

    // collecting terms and condition keys
    const collect_keys = Object.keys(krjson)
      .filter((key) => key.includes('terms_condition'))
      .reduce((obj, key) => {
        if (key.includes('para')) {
          return Object.assign(obj, {
            [key]: krjson[key],
          });
        }
        return Object.assign(obj, {
          [key]: krjson[key],
        });
      }, []);

    let result_collect_keys = Object.entries(collect_keys);

    // collecting privacy policy keys
    const collect_privacy_keys = Object.keys(krjson)
      .filter(
        (key) => key.includes('privacy_section') && key.includes('policy')
      )
      .reduce((obj, key) => {
        if (key.includes('para')) {
          return Object.assign(obj, {
            [key]: krjson[key],
          });
        }
        return Object.assign(obj, {
          [key]: krjson[key],
        });
      }, []);
    let result_collect_privacy_keys = Object.entries(collect_privacy_keys);

    // Collecting entries for table 1
    const table1 = Object.keys(krjson)
      .filter(
        (key) =>
          key.includes('privacy_section') &&
          key.includes('policy') &&
          key.includes('policy3_tr1')
      )
      .reduce((obj, key) => {
        if (key.includes('policy3_tr1')) {
          return Object.assign(obj, {
            [key]: krjson[key],
          });
        }
        return Object.assign(obj, {
          [key]: krjson[key],
        });
      }, []);
    let result_table1 = Object.entries(table1);

    function policy3_table_conditions(render_flag) {
      if (render_flag == true) {
        const rendertable1 = result_table1.map((t1, key) => (
          <div key={key} className={styles.col}>
            {t1[1]}
          </div>
        ));
        return rendertable1;
      }
    }
    let render_flag = false;
    // eo table 1

    // Getting entries for table 2
    const table2 = Object.keys(krjson)
      .filter(
        (key) =>
          key.includes('privacy_section') &&
          key.includes('policy') &&
          key.includes('policy5_tr1')
      )
      .reduce((obj, key) => {
        if (key.includes('policy5_tr1')) {
          return Object.assign(obj, {
            [key]: krjson[key],
          });
        }
        return Object.assign(obj, {
          [key]: krjson[key],
        });
      }, []);
    let result_table2 = Object.entries(table2);

    function policy5_table_conditions(render_flag2) {
      if (render_flag2 == true) {
        const rendertable2 = result_table2.map((t2, key) =>
          t2[0] == 'privacy_section2_policy5_tr1_td1_3' ? (
            <div key={key} className={styles.col2}>
              <>
                {t2[1]}
                <br />
                <br />
                {policy5_tablelis((render_flag3 = true))}
                <br />
              </>
            </div>
          ) : (
            <div key={key} id="tabp" className={styles.col2}>
              {(() => {
                if (!t2[0].includes('_li')) {
                  if (t2[0] == 'privacy_section2_policy5_tr1_td2_3') {
                    return (
                      <>
                        <p key={key} className={styles.col2_se}>
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          {t2[1]}
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                        </p>
                      </>
                    );
                  } else
                    return (
                      <>
                        <p key={key} className={styles.table_para}>
                          {t2[1]}{' '}
                        </p>
                      </>
                    );
                }
              })()}
            </div>
          )
        );
        return rendertable2;
      }
    }
    let render_flag2 = false;
    // eo table 2

    // policy lis
    const tablelis = Object.keys(krjson)
      .filter(
        (key) =>
          key.includes('privacy_section2_policy5_tr1') && key.includes('_li')
      )
      .reduce((obj, key) => {
        if (
          key.includes('privacy_section2_policy5_tr1') &&
          key.includes('_li')
        ) {
          return Object.assign(obj, {
            [key]: krjson[key],
          });
        }
        return Object.assign(obj, {
          [key]: krjson[key],
        });
      }, []);
    let result_tablelis = Object.entries(tablelis);

    function policy5_tablelis(render_flag3) {
      if (render_flag3 == true) {
        const rendertablelis = result_tablelis.map((tlis, key) => (
          <div key={key}>
            {tlis[1]}
            <br />
          </div>
        ));

        return rendertablelis;
      }
    }
    let render_flag3 = false;
    // eo tablelis

    return (
      <div className={componentClasses}>
        <Helmet>
          <title>{t('terms_title')}</title>
        </Helmet>
        <Header toggle={toggle} onToggle={handleToggle} />
        {toggle ? (
          <div className={styles.ContentMobile}>
            <MobileMenu />
          </div>
        ) : (
          <>
            <TermsBanner id="terms_conditions" className={styles.Banner} />
            <TermsBannerResponsive className={styles.BannerResponsive} />
            <div className={styles.Container}>
              <h3 className={styles.PageTitle}>{t('terms_title')}</h3>

              <div className={styles.TextContainer}>
                <h5 id="terms_conditions" className={styles.Title}>
                  {t('terms_IntroText')}
                </h5>

                {result_collect_keys.map((c, key) => (
                  <div id="mapperdiv" key={key}>
                    {(() => {
                      if (c[0].includes('para')) {
                        return (
                          <>
                            {' '}
                            <p key={key} className={styles.Para}>
                              {' '}
                              {c[1]}{' '}
                            </p>{' '}
                          </>
                        );
                      } else {
                        return (
                          <>
                            {' '}
                            <p key={key} className={styles.Subtitle}>
                              {c[1]}{' '}
                            </p>{' '}
                          </>
                        );
                      }
                    })()}
                  </div>
                ))}
              </div>
              {/* // eo Terms */}

              {/* // Privacy policy Start */}
              <div className={styles.TextContainer}>
                <br />
                <br />
                <div id="privacy_policy" name="privacy_policy">
                  <h5 className={styles.Title}>{t('privacy_IntroText')}</h5>
                </div>
                <p className={styles.Para}>{t('privacy_IntroText1')}</p>

                <p className={styles.Subtitle}>
                  {t('privacy_section1_heading')}
                </p>
                <p className={styles.Para}>
                  {t('privacy_section1_heading_intro')}
                </p>
                <p className={styles.Subtitle}>
                  {t('privacy_section1_1title')}
                </p>
                <p className={styles.Para}>{t('privacy_section1_1details')}</p>

                <p className={styles.Subtitle}>
                  {t('privacy_section1_2title')}
                </p>
                <p className={styles.Para}>{t('privacy_section1_2details')}</p>

                <p className={styles.Subtitle}>
                  {t('privacy_section1_3title')}
                </p>
                <p className={styles.Para}>{t('privacy_section1_3details')}</p>
                <br />
                <p className={styles.Subtitle}>
                  {t('privacy_section2_heading')}
                </p>
                <p className={styles.Para}>
                  {t('privacy_section2_heading_intro')}
                </p>

                {result_collect_privacy_keys.map((p, key) => (
                  <div id="mapperdiv" key={key}>
                    {(() => {
                      if (p[0].includes('para')) {
                        return (
                          <>
                            {' '}
                            <p key={key} className={styles.Para}>
                              {' '}
                              {p[1]}{' '}
                            </p>{' '}
                          </>
                        );
                      } else if (p[0].includes('policy3_tr1')) {
                        if (!render_flag) {
                          render_flag = true;
                          return policy3_table_conditions(render_flag);
                        }
                      } else if (p[0].includes('policy5_tr1')) {
                        if (!render_flag2) {
                          render_flag2 = true;
                          return policy5_table_conditions(render_flag2);
                        }
                      } else {
                        return (
                          <>
                            {' '}
                            <p key={key} className={styles.Subtitle}>
                              {p[1]}{' '}
                            </p>{' '}
                          </>
                        );
                      }
                    })()}
                  </div>
                ))}
                <br />
                <br />
                {/* info and consent pages added */}
                <KoInfoConsent t={t}></KoInfoConsent>
                <br />

                <KoAdsConsent t={t}></KoAdsConsent>
              </div>
              {/* // eo Privacy policy */}
            </div>
          </>
        )}{' '}
        <br />
        <br />
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(KoTermsConditions);
